import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Avatar,
  Zoom,
  Fade,
  Chip,
} from '@mui/material';
import { 
  CheckCircle, 
  Login, 
  Refresh,
  Security,
  Lightbulb
} from '@mui/icons-material';

const OTPSuccessMessage = () => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Animation d'entrée
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 300);

    // Nettoyage des données de session après 5 secondes
    const cleanupTimer = setTimeout(() => {
      sessionStorage.removeItem('resetSessionId');
      sessionStorage.removeItem('resetEmail');
      sessionStorage.removeItem('resetToken');
      sessionStorage.removeItem('resetUserEmail');
      sessionStorage.removeItem('resetUserName');
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(cleanupTimer);
    };
  }, []);

  const handleLogin = () => {
    window.location.href = "/"; // Ajustez selon votre configuration
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      {/* Animation de succès */}
      <Zoom in={true} timeout={800}>
        <Avatar
          sx={{
            width: 120,
            height: 120,
            bgcolor: 'success.main',
            margin: '0 auto 24px auto',
            boxShadow: '0 8px 32px rgba(76, 175, 80, 0.3)',
          }}
        >
          <CheckCircle sx={{ fontSize: 80 }} />
        </Avatar>
      </Zoom>

      <Fade in={showContent} timeout={1000}>
        <Box>
          {/* Titre principal */}
          <Typography 
            variant="h4" 
            component="h2" 
            gutterBottom 
            color="success.main"
            sx={{ fontWeight: 700, mb: 2 }}
          >
            🎉 Succès !
          </Typography>

          {/* <Typography 
            variant="h5" 
            component="h3" 
            gutterBottom
            color="text.primary"
            sx={{ fontWeight: 600, mb: 3 }}
          >
            Mot de passe réinitialisé
          </Typography> */}

          {/* Message principal */}
          <Paper 
            sx={{ 
              p: 3, 
              mb: 4, 
              backgroundColor: 'success.50',
              border: '2px solid',
              borderColor: 'success.200'
            }}
          >
            <Typography variant="body1" color="text.primary" paragraph>
              Consultez votre email pour le lien de reinitialisation
            </Typography>
          </Paper>

          {/* Informations de sécurité */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 4 }}>
            <Chip 
              icon={<Security />} 
              label="Connexion sécurisée" 
              color="success" 
              variant="outlined" 
            />
            <Chip 
              icon={<CheckCircle />} 
              label="Mot de passe fort" 
              color="primary" 
              variant="outlined" 
            />
          </Box>

          {/* Boutons d'action */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400, mx: 'auto' }}>
            <Button
              variant="contained"
              size="large"
              onClick={handleLogin}
              startIcon={<Login />}
              sx={{
                py: 1.5,
                background: '#339669',
                '&:hover': {
                  background: '#339669',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(76, 175, 80, 0.4)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              Allez à l'accueil
            </Button>
          </Box>
        </Box>
      </Fade>
    </Box>
  );
};

export default OTPSuccessMessage;